import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FDLMService } from '../services/FDLM.Service'
import { Observable, throwError } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private router: Router, private FDLMService: FDLMService) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const usuario = this.FDLMService.usuarioData;
    if (usuario) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${usuario.token}`
        }
      });
    }
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.FDLMService.logout();
          this.router.navigate(['/login']);
        }
        return throwError(err);
      })
    );
  }
}
